import { gql, type TypedDocumentNode } from '@apollo/client';
import type { CSSProperties } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { BrandS, BrandXS } from '@sorare/core/src/atoms/typography';
import { fantasy } from '@sorare/core/src/lib/glossary';

import type { ThresholdScore_thresholdStreakTaskThreshold } from './__generated__/index.graphql.ts';

const LineThrough = styled(BrandS)`
  text-decoration-line: line-through;
  color: var(--c-nd-600);
`;

type Props = {
  color: string;
  thresholdLowered?: boolean;
  threshold?: ThresholdScore_thresholdStreakTaskThreshold;
  score?: number | null;
};
export const ThresholdScore = ({
  color,
  thresholdLowered,
  threshold,
  score,
}: Props) => {
  return threshold && thresholdLowered ? (
    <Horizontal>
      {!!threshold.originalScore && (
        <LineThrough>{threshold.originalScore}</LineThrough>
      )}
      <BrandXS
        className="text-gradient-color"
        style={
          {
            '--text-gradient-color': `var(--c-gradient-streaks)`,
          } as CSSProperties
        }
      >
        <FormattedMessage
          {...fantasy.pointsWithoutFormat}
          values={{
            score: threshold.score,
          }}
        />
      </BrandXS>
    </Horizontal>
  ) : (
    <BrandXS
      className="text-gradient-color"
      style={
        {
          '--text-gradient-color': color,
          whiteSpace: 'nowrap',
        } as CSSProperties
      }
    >
      <FormattedMessage
        {...fantasy.pointsWithoutFormat}
        values={{
          score: score || threshold?.score,
        }}
      />
    </BrandXS>
  );
};

ThresholdScore.fragments = {
  thresholdStreakTaskThreshold: gql`
    fragment ThresholdScore_thresholdStreakTaskThreshold on ThresholdStreakTaskThreshold {
      score
      originalScore
    }
  ` as TypedDocumentNode<ThresholdScore_thresholdStreakTaskThreshold>,
};
